import React                       from 'react';
import { connect }                 from 'react-redux';
import { createRouteNodeSelector } from 'redux-router5';
import * as Layouts                from 'pursuit/components/Layouts';
import ReduxToastr                 from 'react-redux-toastr';

require('pursuit/scss/global.scss');

function AppContainer(props) {
    return (
        <div id="appContainer" className="app-container">
            <Layouts.Main />
            <ReduxToastr
                timeOut={8000}
                newestOnTop={false}
                preventDuplicates
                position="top-right"
                transitionIn="fadeIn"
                transitionOut="fadeOut"
                progressBar
            />
        </div>
    )
}

export default connect(createRouteNodeSelector(''))(AppContainer);
